import { CompanyInstance } from '@/store'
import { catchError } from '@/utils/catchError'

const merchant = {
  state: {
    merchantName: null,
    summary: null
  },
  mutations: {
    'SET_MERCHANT_NAME' (state, merchantName) {
      state.merchantName = merchantName
    },
    'SET_MERCHANT_SUMMARY' (state, payload) {
      state.summary = payload
    }
  },
  getters: {
    merchantName (state) {
      return state.merchantName
    },
    merchantSummary (state) {
      return state.summary
    }
  },
  actions: {
    'SET_MERCHANT_SUMMARY' (context, value) {
      context.commit('SET_MERCHANT_SUMMARY', value)
    },
    'GET_MERCHANT_SUMMARY' (context, merchantId) {
      return CompanyInstance.merchant.getSummary(merchantId, 'shop', process.env)
        .then(res => {
          context.commit('SET_MERCHANT_NAME', res.name)
          context.commit('SET_MERCHANT_SUMMARY', res)
          context.dispatch('updateWhitelabel', res.whitelabel)
          return Promise.resolve(res)
        })
        .catch(err => catchError(err, context))
    }
  }
}

export default merchant
